// @ts-nocheck

import { useEffect } from "react";

const PARTNER_ID = "8426889";

function bootstrap() {
  window._linkedin_partner_id = PARTNER_ID;
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push(window._linkedin_partner_id);
}

function loadScript() {
  (function (w, d) {
    if (!w.lintrk) {
      w.lintrk = function (a, b) {
        w.lintrk.q = w.lintrk.q || [];
        w.lintrk.q.push([a, b]);
      };
      w.lintrk.q = [];
    }

    var s = d.getElementsByTagName("script")[0];
    var b = d.createElement("script");
    b.type = "text/javascript";
    b.async = true;
    b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
    s.parentNode.insertBefore(b, s);
  })(window, document);
}

function useLinkedInInsightTag(enabled = false, timeout = 0) {
  useEffect(() => {
    if (!enabled) return;

    bootstrap();

    const timeoutId = window.setTimeout(loadScript, timeout);

    return () => window.clearTimeout(timeoutId);
  }, [enabled, timeout]);
}

export default useLinkedInInsightTag;
